import { useAssessmentSettings } from '@/api/useAssessmentSettings';

/**
 * This component will preload SWR api backend calls.
 *
 * Preload api calls for most frequently visited page.
 * Can block app from rendering for crucial backend call with care.
 */
const PreloadApi = ({ children }: React.PropsWithChildren) => {
    useAssessmentSettings();

    return children;
};

export default PreloadApi;
